import React from "react"

import Logo from "../../../assets/svg/logo.inline.svg"
import { Link } from "../../common/link/Link"

import type { Props } from "./LogoHeader.interface"

import * as s from "./LogoHeader.module.scss"

export const LogoHeader = ({ className }: Props) => {
  return (
    <div className={`${s.logoHeader} ${className && className}`}>
      <div className={s.logoHeader__logoWrapper}>
        <Link to="/">
          <Logo />
        </Link>
      </div>
    </div>
  )
}
